<div class="p-4 lg:p-10 flex-1 flex flex-col">
  <div class="hidden md:flex items-center justify-end gap-6">
    <span class="font-efSans-primary"></span>
    <span class="font-efSans-primary" *ngIf="registrationEnabled">
      <T
        str="Don't have an account yet?"
        key="customerPortal.kc.reset-password.top-bar.register-label"
        tags="kc-forms, 3.1"
      >
      </T>
    </span>
    <a *ngIf="registrationEnabled" [href]="viewData.registrationUrl">
      <button
        class="revolution ef-branding"
        mat-button
        mat-stroked-button
        color="secondary"
      >
        <T
          str="Register"
          key="customerPortal.kc.reset-password.top-bar.register-button"
          tags="kc-forms, 3.1"
        >
        </T>
      </button>
    </a>
  </div>
  <div class="welcome flex flex-col gap-6 py-6">
    <div class="font-efSans-secondary font-semibold uppercase">
      {{ 'customer-portal' | sharedTranslate }}
    </div>
    <div class="font-canelablack-primary text-4xl md:text-5xl">
      <T
        str="Forgot Password"
        key="customerPortal.kc.reset-password.title"
        tags="kc-forms, 3.1"
      >
      </T>
    </div>
    <div
      class="text-mat-ef-revolution-primary-500 font-efSans text-xl font-light"
      *ngIf="!sent"
    >
      <T
        str="We will email you a link to reset your password."
        key="customerPortal.kc.reset-password.subtitle"
        tags="kc-forms, 3.1"
      >
      </T>
    </div>
  </div>
  <div class="login-form w-full lg:w-1/2 py-6 flex-1" *ngIf="!sent">
    <form
      class="flex flex-col gap-3"
      #loginForm
      [formGroup]="form"
      method="POST"
      [action]="viewData.loginAction"
      (ngSubmit)="reset()"
    >
      <mat-form-field class="email">
        <mat-label>
          <T
            str="Enter your email"
            key="customerPortal.kc.reset-password.email"
            tags="kc-forms, 3.1"
          >
          </T>
        </mat-label>
        <mat-icon matPrefix svgIcon="alternate_email"></mat-icon>
        <input
          class="input"
          matInput
          required
          formControlName="email"
          name="email"
        />
        <mat-icon
          *ngIf="form.controls.email.touched && form.controls.email.invalid"
          matSuffix
          color="error"
          svgIcon="error_outline"
        ></mat-icon>
        <mat-error *ngIf="form.controls.email.invalid">
          {{
            transifexService.getErrorTranslation(
              form.controls.email,
              'customerPortal.kc.reset-password.email.error.',
              {
                errKey: {
                  pattern: 'enter-valid-email',
                  email: 'enter-valid-email',
                  maxlength: 'maximum-length-exceeded'
                }
              }
            )
          }}
        </mat-error>
      </mat-form-field>
      <div class="reset-button">
        <input type="hidden" name="login" />
        <button
          mat-button
          mat-raised-button
          color="secondary"
          type="submit"
          class="w-full py-2 revolution button-spinner"
          [disabled]="!form.valid"
        >
          <customer-portal-ef-spinner
            [color]="'mat-ef-revolution-grey-two-500'"
            [opacity]="0.7"
            [diameter]="16"
            *ngIf="sent"
          >
          </customer-portal-ef-spinner>
          <T
            str="Send"
            key="customerPortal.kc.reset-password.button"
            tags="kc-forms, 3.1"
          >
          </T>
        </button>
      </div>
      <a
        *ngIf="registrationEnabled"
        mat-button
        mat-raised-button
        color="secondary"
        class="w-full py-2 revolution inline-block md:hidden"
        [href]="viewData.registrationUrl"
      >
        <T
          str="Register"
          key="customerPortal.kc.register.button"
          tags="kc-forms, 3.1"
        ></T>
      </a>
    </form>
  </div>
  <div *ngIf="sent" class="py-6">
    <mat-card
      class="flex flex-row gap-6 items-center  py-7 px-10 mb-5 border border-at-ef-revolution-supergrey-500 rounded-lg mat-elevation-z0"
    >
      <mat-icon
        class="card-flex-rounded-icon"
        svgIcon="check_circle_outline"
      ></mat-icon>
      <p class="font-efSans-primary" [innerHTML]="getTranslation()"></p>
    </mat-card>
  </div>
</div>
